import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { first, map } from 'rxjs/operators';

import { basePath } from '@atmi/core/injection';
import { ResponsePaginateSuccess, ResponseSuccess, Term, Vocabulary } from '@atmi/core/models';
import { generateIndexQueryString, IndexQueryStringType } from '@atmi/core/utils';

@Injectable()
export class VocabularyService {
  private readonly urlVocabulary = `${this.baseUrl}/vocabolari`;
  private readonly urlTerm = `${this.baseUrl}/termini`;

  constructor(
    private readonly http: HttpClient,
    @Inject(basePath) private readonly baseUrl: string,
  ) {
  }

  indexVocabulary() {
    return this.http.get<ResponseSuccess<Vocabulary[]>>(this.urlVocabulary).pipe(
      map((res) => res.data),
    );
  }

  getVocabulary(id: string) {
    return this.http.get<ResponseSuccess<Vocabulary>>(`${this.urlVocabulary}/${id}`);
  }

  getTermsFromVocabulary(id: string, queryString?: IndexQueryStringType) {
    const params = generateIndexQueryString(queryString);

    return this.http.get<ResponsePaginateSuccess<Term[]>>(`${this.urlVocabulary}/${id}/termini`, { params });
  }

  getTerms(queryString?: IndexQueryStringType) {
    const params = generateIndexQueryString(queryString);

    return this.http.get<ResponsePaginateSuccess<Term[]>>(this.urlTerm, { params });
  }

  searchTerms(q: string, vocabulary: string, parentTerm?: Term) {
    let params = new HttpParams({ fromObject: { filter: `^${q}`, vocabolario: vocabulary } });

    if (parentTerm && parentTerm.id) {
      params = params.append('termineGenitore', parentTerm.id);
    }

    return this.http.get<ResponsePaginateSuccess<Term[]>>(this.urlTerm, { params });
  }

  postTerm(term: Term) {
    return this.http.post<ResponseSuccess<Term>>(this.urlTerm, term).pipe(first());
  }

  putTerm(term: Term & { id: string }) {
    return this.http.put<ResponseSuccess<Term>>(`${this.urlTerm}/${term.id}`, term).pipe(first());
  }

  deleteTerm(id: string) {
    return this.http.delete<any>(`${this.urlTerm}/${id}`).pipe(first());
  }
}
